module.exports = __webpack_public_path__ + "static/avatar-79fbe15690e99e0fd46ddf8da3f17937.jpg";